<template>
  <div id="app">
    <v-app :style="{background: $vuetify.theme.themes[theme].background}">

      <v-main>

        <h1>
          <!-- メインビューブロック SP表示-->
          <v-img v-if="isMobileDevice()" :aspect-ratio="10/14.08" :width="width" :src="kv_sp"
            alt="NAKEDの最新アート展は占い×テクノロジー×アートの超体験！">
            <div class="py-4"></div>
          </v-img>
        </h1>
        <h1>
          <!-- メインビューブロック PC表示-->
          <v-img v-if="!isMobileDevice()" :aspect-ratio="20/11.25" :width="width" :src="kv_pc"
            alt="NAKEDの最新アート展は占い×テクノロジー×アートの超体験！">
            <div class="py-4"></div>
          </v-img>
        </h1>

        <!-- NakedLP.vue読み込み -->
        <NakedLP />


      <!-- 固定購入ボタン <v-footer class="footer">
        <v-container>
          <v-layout v-bind="binding">
            <v-flex xs12 sm6 offset-sm-3 text-center py-2>
              <v-btn color="#fd0a8c" :href="ticket_url" width="90%" height="50" target="_blank" class="border-white">
                <span class="text-sm-body-2 text-md-body-1">
                  チケット購入
                </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer> -->

      </v-main>


    </v-app>
  </div>
</template>

<script>
  import NakedLP from './components/NakedLP';
  import isMobile from "ismobilejs";

  export default {
    name: 'App',

    components: {
      NakedLP,
    },

    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.xsOnly) binding.row = true

        return binding
      },
      theme() {
        return this.$vuetify.theme.dark ? "dark" : "light";
      },
    },

    data: () => ({
      // キービジュアル
      kv_sp: './Images/KV_naked_uranai_colla2_sp.jpg',
      kv_pc: './Images/KV_naked_uranai_colla2_pc.jpg',

      // コーポレートロゴ
      cp_logo: './Images/NAKED,INC._Logotype_w.svg',

      // チケット購入URL
      ticket_url: 'https://ticket.tv-asahi.co.jp/ex/project/H5RIhbjzdY',



      //キータイトル
      key_title: './Images/NAKED,INC._Logotype_w.svg',


      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function () {
        if (isMobile().any) {
          return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug: false

    }),




  };
</script>


<style lang="scss" scoped>
  html {
    font-family: "Yu Gothic", "Roboto", "Helvetica Neue", "Helvetica", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Arial", "Meiryo", sans-serif;
  }

  .border-white {
    border: 2px solid #fff !important;
  }


  .container {
    padding: 12px 24px;
  }

  .footer {
    position: sticky;
    bottom: 0;
    z-index: 999;
    background: linear-gradient(180deg, rgb(138 85 241) 0%, rgb(1 140 160) 100%);
  }
</style>